import { useState, useEffect } from 'react';
import Papa from 'papaparse';
import { CME_DATA_PATH } from '../constants';

/**
 * Custom hook for loading and managing CME (Care Management Entity) data
 * @returns {Object} { data, loading, error }
 */
export const useCMEData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);

        Papa.parse(CME_DATA_PATH, {
          download: true,
          header: true,
          complete: (results) => {
            // Transform Counties string to array
            const transformedData = results.data.map((row) => ({
              ...row,
              Counties: row.Counties.split(',').map((county) => county.trim())
            }));

            setData(transformedData);
            setLoading(false);
          },
          error: (parseError) => {
            console.error('Error loading CSV:', parseError);
            setError(parseError);
            setLoading(false);
          }
        });
      } catch (err) {
        console.error('Error in data loading:', err);
        setError(err);
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return { data, loading, error };
};
